import React from 'react'
import './trade-portal-post-card.styles.scss'
import { format } from 'date-fns'
import ImageContainer from '../image-container/image-container.component'
import { useSelector } from 'react-redux'
import UserIcon from '@/components/layout-auth/user-icon/user-icon.component'
import PlayerNameIcon from '@/components/PLAYER/player-blocks/components/status-elements/player-name-icon.component'
import { properCase } from '@/utils/properCase'

const TradePortalPostCard = ({
  post,
  gameElements,
  isOwn,
  onClick,
  playerList
}) => {

  const screenSize = useSelector((state) => state.contentData.screenSize)
  const offeringEl = gameElements?.[post.offering?.itemId]
  const approvedOffer = post.approvedOfferId ? post.offers?.[post.approvedOfferId] : null

  const pendingOfferCount = Object.values(post.offers ?? {})
    .filter((o) => o.status === 'pending').length

  function getItemLabel(item) {
    if (item.type === 'currency') return `${item.quantity} Currency`
    if (item.type === 'points') return `${item.quantity} Points`
    const el = gameElements?.[item.itemId]
    const name = el?.name ?? item.itemId
    return item.quantity > 1 ? `${item.quantity}× ${name}` : name
  }

  function getRequestLabel(req) {
    if (req.type === 'currency') return `${req.quantity} Currency`
    if (req.type === 'points') return `${req.quantity} Points`
    const el = gameElements?.[req.itemId]
    const name = el?.name ?? req.itemId
    return req.quantity > 1 ? `${req.quantity}x ${name}` : name
  }

  function formatTs(ts) {
    if (!ts) return ''
    try {
      const d = ts.toDate ? ts.toDate() : new Date(ts)
      return format(d, 'MMM d')
    } catch {
      return ''
    }
  }

  const isVertical = screenSize === 'mobile' || screenSize === 'tablet'

  return (
    <div className='trade-post-card' onClick={onClick}>
      <span className='poster-name'>
        <PlayerNameIcon
          player={playerList[post.posterId]}
          reverse={true} />
      </span>
      <div className="g-space-0-5"></div>
      <hr className='no-margin' />

      {(post.status === 'completed' || post.status === 'reversed') && approvedOffer ? (
        <>
          <div className={`card-completed-summary${post.status === 'reversed' ? ' reversed' : ''}`}>
            <div className='card-completed-columns'>
              <div className='card-completed-player'>
                <span className='card-completed-name'>{post.posterName}</span>
                <span className='card-completed-label'>
                  {post.status === 'reversed' ? 'got back' : 'received'}
                </span>
                <div className='tp-completion-items'>
                  {post.status === 'reversed' ? (
                    (() => {
                      const label = getItemLabel(post.offering)
                      return (
                        <div className='tp-completion-item-card' title={label}>
                          {offeringEl?.icon && <ImageContainer src={offeringEl.icon} alt='' className='tp-completion-item-icon' />}
                          <span className='tp-completion-item-name'>{label}</span>
                        </div>
                      )
                    })()
                  ) : (
                    approvedOffer.items?.length > 0
                      ? approvedOffer.items.map((item, i) => {
                          const el = item.itemId ? gameElements?.[item.itemId] : null
                          const label = getItemLabel(item)
                          const icon = el?.icon
                            ?? (item.type === 'currency' ? '/images/icons/coin.png'
                              : item.type === 'points' ? '/images/icons/xp.png'
                              : null)
                          return (
                            <div key={i} className='tp-completion-item-card' title={label}>
                              {icon && <ImageContainer src={icon} alt='' className='tp-completion-item-icon' />}
                              <span className='tp-completion-item-name'>{label}</span>
                            </div>
                          )
                        })
                      : <span className='card-completed-nothing'>Nothing</span>
                  )}
                </div>
              </div>
              <div className='card-completed-player'>
                <span className='card-completed-name'>{approvedOffer.offererName}</span>
                <span className='card-completed-label'>
                  {post.status === 'reversed' ? 'got back' : 'received'}
                </span>
                <div className='tp-completion-items'>
                  {post.status === 'reversed' ? (
                    approvedOffer.items?.length > 0
                      ? approvedOffer.items.map((item, i) => {
                          const el = item.itemId ? gameElements?.[item.itemId] : null
                          const label = getItemLabel(item)
                          const icon = el?.icon
                            ?? (item.type === 'currency' ? '/images/icons/coin.png'
                              : item.type === 'points' ? '/images/icons/xp.png'
                              : null)
                          return (
                            <div key={i} className='tp-completion-item-card' title={label}>
                              {icon && <ImageContainer src={icon} alt='' className='tp-completion-item-icon' />}
                              <span className='tp-completion-item-name'>{label}</span>
                            </div>
                          )
                        })
                      : <span className='card-completed-nothing'>Nothing</span>
                  ) : (
                    (() => {
                      const label = getItemLabel(post.offering)
                      return (
                        <div className='tp-completion-item-card' title={label}>
                          {offeringEl?.icon && <ImageContainer src={offeringEl.icon} alt='' className='tp-completion-item-icon' />}
                          <span className='tp-completion-item-name'>{label}</span>
                        </div>
                      )
                    })()
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='card-meta'>
            <span className='meta-date'>{formatTs(post.ts_created)}</span>
            <span className={`post-status ${post.status}`}>{properCase(post.status?.replace('_', ' '))}</span>
          </div>
        </>
      ) : (
        <div className={`card-grid${isVertical ? ' vertical' : ''}`}>
          <div className='offer-request-container'>
            <div className="g-space-0-5"></div>
            <div className='meta'>Offering...</div>
            <div className="g-space-0-5"></div>
            <div className='item-card' title={offeringEl?.name}>
              {offeringEl?.icon && (
                <ImageContainer src={offeringEl.icon} alt={offeringEl.name} />
              )}
              <span className='offering-name'>{offeringEl?.name ?? 'Item'}</span>
              {post.offering?.quantity > 1 && (
                <span className='offering-qty'>x{post.offering.quantity}</span>
              )}
            </div>
          </div>

          <span className='card-arrow'>{isVertical ? '↓' : '→'}</span>

          <div className='requesting'>
            {post.requesting?.length > 0
              ?
              <div className='offer-request-container'>
                <div className='meta'>Requesting...</div>
                <div className="g-space-0-5"></div>
                <div className='request-list'>
                  {post.requesting.map((r, i) => {
                    if (r.type === 'currency') {
                      return (
                        <div key={i} className='item-card' title={`${r.quantity} Currency`}>
                          <ImageContainer src="/images/icons/coin.png" alt={getRequestLabel(r)} />
                          <span className='offering-name'>{getRequestLabel(r)}</span>
                        </div>
                      )
                    }
                    const element = gameElements?.[r.itemId]
                    return (
                      <div key={i} className='item-card' title={element?.name}>
                        {element?.icon && (
                          <ImageContainer src={element.icon} alt={element.name} />
                        )}
                        <span className='offering-name'>{getRequestLabel(r)}</span>
                      </div>
                    )
                  })}
                </div>
              </div>
              : <span className='open-offer-text'>Open to offers</span>
            }
          </div>

          <div className='card-meta'>
            <span className='meta-date'>{formatTs(post.ts_created)}</span>
            {isOwn && pendingOfferCount > 0 && (
              <span className='meta-offers'>
                {pendingOfferCount} offer{pendingOfferCount !== 1 ? 's' : ''}
              </span>
            )}
            <span className={`post-status ${post.status}`}>
              {properCase(post.status?.replace('_', ' '))}
            </span>
          </div>
        </div>
      )}
    </div>
  )
}

export default TradePortalPostCard
